import { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function NewsletterSignup({ language }) {
  const isAr = language === 'ar';
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [gdpr, setGdpr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const texts = {
    en: { title: 'Stay Updated on Istanbul', subtitle: 'Get exclusive travel tips, property insights, and tour updates delivered to your inbox.', namePh: 'Your name (optional)', emailPh: 'Your email address', gdprLabel: 'I agree to receive marketing emails and accept the privacy policy', btn: 'Subscribe', success: 'Thank you for subscribing!', already: 'You\'re already subscribed!', error: 'Something went wrong. Please try again.' },
    ar: { title: 'ابقَ على اطلاع بأخبار إسطنبول', subtitle: 'احصل على نصائح سفر حصرية ورؤى عقارية وتحديثات الجولات مباشرة إلى بريدك الإلكتروني.', namePh: 'اسمك (اختياري)', emailPh: 'بريدك الإلكتروني', gdprLabel: 'أوافق على تلقي رسائل تسويقية وأقبل سياسة الخصوصية', btn: 'اشترك', success: 'شكراً لاشتراكك!', already: 'أنت مشترك بالفعل!', error: 'حدث خطأ. يرجى المحاولة مرة أخرى.' },
    ru: { title: 'Будьте в курсе новостей Стамбула', subtitle: 'Получайте эксклюзивные советы, обзоры недвижимости и обновления туров.', namePh: 'Ваше имя (необязательно)', emailPh: 'Ваш email', gdprLabel: 'Я согласен получать маркетинговые письма и принимаю политику конфиденциальности', btn: 'Подписаться', success: 'Спасибо за подписку!', already: 'Вы уже подписаны!', error: 'Произошла ошибка. Попробуйте снова.' },
    tr: { title: 'İstanbul haberlerinden haberdar olun', subtitle: 'Özel seyahat ipuçları, emlak bilgileri ve tur güncellemeleri alın.', namePh: 'Adınız (isteğe bağlı)', emailPh: 'E-posta adresiniz', gdprLabel: 'Pazarlama e-postaları almayı ve gizlilik politikasını kabul ediyorum', btn: 'Abone Ol', success: 'Abone olduğunuz için teşekkürler!', already: 'Zaten abonesiniz!', error: 'Bir hata oluştu. Lütfen tekrar deneyin.' }
  };
  const tx = texts[language] || texts.en;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !gdpr) return;
    setLoading(true); setMsg(null);
    try {
      const res = await axios.post(`${API}/api/newsletter`, { email, name: name || undefined });
      setMsg({ type: 'success', text: res.data.message === 'Already subscribed!' ? tx.already : tx.success });
      setEmail(''); setName(''); setGdpr(false);
    } catch {
      setMsg({ type: 'error', text: tx.error });
    } finally { setLoading(false); }
  };

  return (
    <div className="newsletter-signup" dir={isAr ? 'rtl' : 'ltr'} data-testid="newsletter-signup">
      <div className="nl-content">
        <h3>{tx.title}</h3>
        <p>{tx.subtitle}</p>
        <form onSubmit={handleSubmit} className="nl-form" data-testid="newsletter-form">
          <div className="nl-fields">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder={tx.namePh} className="nl-input" data-testid="nl-name" />
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={tx.emailPh} required className="nl-input" data-testid="nl-email" />
            <button type="submit" disabled={loading || !gdpr} className="nl-btn" data-testid="nl-submit">
              {loading ? '...' : tx.btn}
            </button>
          </div>
          <label className="nl-gdpr" data-testid="nl-gdpr">
            <input type="checkbox" checked={gdpr} onChange={e => setGdpr(e.target.checked)} />
            <span>{tx.gdprLabel}</span>
          </label>
          {msg && <div className={`nl-msg nl-msg-${msg.type}`} data-testid="nl-message">{msg.text}</div>}
        </form>
      </div>
    </div>
  );
}
